export const SURVEY_SOURCE = 'website';

export enum SURVEY_NAME {
  METRO_PT_ONBOARDING = 'Metro PT Onboarding',
  DEMOGRAPHIC = 'Demographic',
  POST_PURCHASE = 'Post-Purchase',
  NEW_ONBOARDING = 'New Onboarding',
  REACTIVATION_ONBOARDING = 'Reactivation Onboarding',
  CHANGE_STAGE = 'Change Stage',
  END_OF_PATH = 'End of Path',
  ST_ONBOARDING = 'Symptom Tracking Onboarding',
  REACTIVATION_ST_ONBOARDING = 'Reactivation Symptom Tracking Onboarding',
  ST = 'Symptom Tracking',
  MEASUREMENT_TRACKER = 'Measurement Tracker',
}

export enum SURVEY_TRIGGER {
  ONBOARDING = 'onboarding',
  CHANGE_STAGE = 'change_stage',
  PATH_END_WHERE_NEXT = 'path_end_where_next',
  IM_READY_PATH_END = 'im_ready_path_end',
  IM_READY_GUIDED_PATHS = 'im_ready_guided_paths',
  IM_READY_MY_PATH = 'im_ready_my_path',
  ST_CHECKIN = 'symptom_tracking_checkin',
  EDIT_MEASUREMENT_TRACKER = 'edit_measurement_tracker',
}

export enum PAYMENT_METHOD {
  CHARGEBEE = 'chargebee',
  FLEX = 'flex',
}

interface QuestionAnsweredContext {
  question_answered_count: number;
}

interface SurveyMeta {
  survey_version: number;
  source: string;
  survey_trigger: SURVEY_TRIGGER;
}

export interface QuestionAnsweredEvent {
  survey_name: SURVEY_NAME;
  question: string;
  answer: any;
  survey_meta: SurveyMeta;
  question_answered_context?: QuestionAnsweredContext;
}

export interface ReferFriendInitiatedEvent {
  cta: string;
  source: string;
}

export interface WebViewEvent {
  modal_viewed: string;
}

export interface PaymentMethodEvent {
  payment_method: PAYMENT_METHOD;
}

export interface FeatureExposedEvent {
  feature_name: string;
  exposure_type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  variant: Record<string, any> | null;
  enabled: boolean;
}

interface BaseSurveyEvent {
  survey_name: SURVEY_NAME;
  activation_cycle_count: number;
  survey_meta: SurveyMeta;
  personalization_count?: number;
  reclaim_symptom_tracking_cycle?: number;
  reclaim_symptom_tracking_number?: number;
}

export type SurveyStartedEvent = BaseSurveyEvent;

export interface SurveyFinishedEvent extends BaseSurveyEvent {
  survey_questions: object;
}

export enum PATH_RECOMMENDATION_CONTEXT {
  PRE_PAYWALL_ONBOARDING = 'Pre-Paywall Onboarding',
  POST_PAYWALL_ONBOARDING = 'Post-Paywall Onboarding',
  CHANGE_STAGE_SURVEY = 'Change Stage Survey',
}

export interface PathRecommendationViewedEvent {
  path_recommendation_context: PATH_RECOMMENDATION_CONTEXT;
  path_recommended: string;
}

export enum Trimester {
  FIRST_TRIMESTER = 'First Trimester',
  SECOND_TRIMESTER = 'Second Trimester',
  THIRD_TRIMESTER = 'Third Trimester',
  UNKNOWN = 'Unknown',
}

export interface DueDateRecordEvent {
  due_date: string;
  days_until_due_date: number;
  trimester: Trimester;
}
